import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 34, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, duration = 1 }) => (
  <span className="mask-line">
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, chapter, dark = false }) => (
  <div className="flex items-center gap-4 mb-6">
    {chapter && (
      <span className="font-mono-t text-xs px-2 py-1 bg-[#f95700] text-white font-semibold">
        {chapter}
      </span>
    )}
    <span className={`eyebrow ${dark ? "text-neutral-500" : "text-[#f95700]"}`}>{children}</span>
    <span className="hairline flex-1 max-w-[140px]" />
  </div>
);
